require('./bootstrap');
require('./hamburger');
require('./newsletter');
// require('./cookie');
// require('./slide-to-section');
require('./smooth-scroll');
// require('./visible');
// require('./sendmail');


require('bootstrap-datepicker');

$(document).ready(function() {
    $('#newsletterModal').modal('show');
    $("#datepicker").datepicker({
        format: 'mm/dd',
        autoclose: true,
        startView: 1,
        maxViewMode: "months",
        orientation: "bottom left",
    });

    $("#birthdaydatepicker").datepicker({
        format: 'yyyy/mm/dd',
        autoclose: true,
        startView: 1,
        maxViewMode: "years",
        orientation: "bottom left",
    });

});

function onScroll(event) {
    const element = $('h2 span');
    element.each(function(i, elem) {
        if ($(elem).visible(true)) {
            var windowHeight = window.innerHeight;
            let width =  100 - ($(elem).offset().top - $(window).scrollTop()) / windowHeight * 100;
            elem.style.setProperty('--width', width * 1.5 + 'vw');
        }
    });
}
